import React, { useContext, useState } from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { FormProvider } from 'react-hook-form';

import { ImageUploader } from '@vyce/core/src/components';
import { ButtonTitleWithLoading } from '@vyce/core/src/components/ButtonTitleWithLoading';
import { DeviceContext } from '@vyce/core/src/contexts/deviceContext';
import { MAIN_CONTAINER_ID } from '../../../constants';
import { TeamNameField } from '../../teams/components/TeamNameField';
import { TeamDescriptionField } from '../../teams/components/TeamDescriptionField';
import { TeamModuleContext } from '../../../contexts';
import { CreateTeamData } from '../../../api/types';

const buttonPosition = { right: 24 };

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const EditTeamDialog = ({ isOpen, onClose }: Props) => {
  const { isDesktop, isMobile } = useContext(DeviceContext);
  const { logo, methods, setLogo, handleSubmit } = useContext(TeamModuleContext);
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async (data: CreateTeamData) => {
    try {
      setLoading(true);
      await handleSubmit(data);
      onClose();
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog
      fullScreen={isMobile}
      container={document.getElementById(MAIN_CONTAINER_ID)}
      open={isOpen}
      maxWidth="lg"
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogTitle id="responsive-dialog-title">Edit Team</DialogTitle>

          <DialogContent style={{ width: isDesktop ? '500px' : '100%' }}>
            <Box position="relative" display="flex" flexDirection="column" gridGap={8}>
              <Box marginBottom={1} marginTop={2}>
                <ImageUploader
                  width={170}
                  height={120}
                  image={logo}
                  isDocument={true}
                  onImageUpload={image => {
                    setLogo(image);
                    methods.setValue('logo', image);
                  }}
                  extraText="team picture"
                  buttonPosition={buttonPosition}
                />
              </Box>

              <TeamNameField />

              <TeamDescriptionField />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button size="large" disabled={loading} variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button
              style={{ width: 150 }}
              size="large"
              color="primary"
              cy-test-id="add-existing-user-to-team-button"
              variant="contained"
              disabled={loading}
              type="submit"
            >
              <ButtonTitleWithLoading title="Save changes" loaderVariant="paper" loading={loading} />
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};
